import { Box, Grid, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import BadgeDetached from "@entrilia/shared/components/BadgeDetached";
import type { OrganizationCompaniesGroup } from "../../leftSideMenu/client-selector/client-selector-helper";
import ClientCard from "./ClientCard";

interface Props {
  groups: OrganizationCompaniesGroup[];
}

const ClientsGridView = ({ groups }: Props) => {
  const navigate = useNavigate();

  return (
    <>
      {groups.map((value) => (
        <Stack key={value.organization?.clientCode ?? "unmanaged"} sx={{ gap: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 1 }}>
            <Typography variant="subtitle1">{value.organization?.title || "Unmanaged"}</Typography>
            <BadgeDetached
              badgeContent={value.companies.length}
              color="secondary"
              sx={(t) => ({ color: t.palette.secondary.main })}
            />
          </Box>
          <Grid container spacing={2}>
            {value.companies.map((client) => (
              <Grid key={client.clientCode}>
                <ClientCard client={client} onClick={() => navigate(`/${client.clientCode}`)} />
              </Grid>
            ))}
          </Grid>
        </Stack>
      ))}
    </>
  );
};

export default ClientsGridView;
